// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DynamicFormFieldPayloadModel from '../../model/dynamic-form-field-payload-model';
import DynamicFormFieldPayloadDTO from '../dto/dynamic-form-field-payload-dto';

export default abstract class DynamicFormFieldPayloadModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DynamicFormFieldPayloadDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.values = data.values;
    }
  }
  /**
  */
  'id'?: string;
  /**
  */
  'values'?: any[];

  static toModel(dto: DeepPartial<DynamicFormFieldPayloadDTO>): DynamicFormFieldPayloadModel;
  static toModel(dto: DeepPartial<DynamicFormFieldPayloadDTO> | undefined | null): DynamicFormFieldPayloadModel | undefined;
  static toModel(dto: DeepPartial<DynamicFormFieldPayloadDTO> | undefined | null): DynamicFormFieldPayloadModel | undefined {
    return dto ? new DynamicFormFieldPayloadModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DynamicFormFieldPayloadModel> | DynamicFormFieldPayloadModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'id': unwrapped.id,
      'values': unwrapped.values,
    } as DynamicFormFieldPayloadDTO;
  }
}
